import script from "./BarArrowButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BarArrowButton.vue?vue&type=script&setup=true&lang=ts"

import "./BarArrowButton.vue?vue&type=style&index=0&id=14a3e3a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14a3e3a6"]])

export default __exports__